import React, { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import type { CreateCategoryPayload } from '../../../hooks/useMerchantMenu';

export interface AddCategoryModalProps {
  open: boolean;
  onSubmit: (payload: CreateCategoryPayload) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

export const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  open,
  onSubmit,
  onCancel,
  loading = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload: CreateCategoryPayload = {
        name: values.name?.trim() ?? '',
        description: values.description?.trim() || undefined,
      };
      await onSubmit(payload);
      form.resetFields();
      onCancel();
    } catch {
      // Validation or submit error
    }
  };

  return (
    <Modal
      title="Thêm danh mục"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Thêm"
      cancelText="Hủy"
      destroyOnClose
      width={440}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="name"
          label="Tên danh mục"
          rules={[{ required: true, message: 'Nhập tên danh mục' }]}
        >
          <Input placeholder="Ví dụ: Món chính, Đồ uống" />
        </Form.Item>
        <Form.Item name="description" label="Mô tả">
          <Input.TextArea rows={2} placeholder="Tùy chọn" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
